function fgMatrix2D(elements) {
  const m = new Float32Array(4);
  if (elements) {
    m.set(elements);
  } else {
    m[0] = 1;
    m[3] = 1;
  }
  return { m, __fgMat: 2 };
}
function fgMatrix3D(elements) {
  const m = new Float32Array(9);
  if (elements) {
    m.set(elements);
  } else {
    m[0] = 1;
    m[4] = 1;
    m[8] = 1;
  }
  return { m, __fgMat: 3 };
}
function isFgMatrix2D(v) {
  return typeof v === "object" && v !== null && v.__fgMat === 2;
}
function isFgMatrix3D(v) {
  return typeof v === "object" && v !== null && v.__fgMat === 3;
}

export { fgMatrix2D, fgMatrix3D, isFgMatrix2D, isFgMatrix3D };
//# sourceMappingURL=fg-matrix.js.map
